import classNames from "classnames";
import { forwardRef, HTMLAttributes } from "react";

import FieldGroupAppend from "./components/FieldGroupAppend";
import FieldGroupPrepend from "./components/FieldGroupPrepend";
import { FieldGroupWrapper } from "./FieldGroup.styled";

import { PropsWithAs } from "src/types/componentProps";

export type FieldGroupProps = HTMLAttributes<HTMLDivElement> &
  PropsWithAs & {
    noInnerBorder?: boolean;
  };

const FieldGroupComponent = forwardRef<HTMLDivElement, FieldGroupProps>((props, ref) => {
  const { className, ...restProps } = props;
  const fieldGroupClass = classNames("c-field-group", className);

  return <FieldGroupWrapper data-testid="qa-field-group" ref={ref} className={fieldGroupClass} {...restProps} />;
});

const FieldGroup = Object.assign(FieldGroupComponent, {
  /**
   * Prepend is the first side of field
   */
  Prepend: FieldGroupPrepend,

  /**
   * Append is the end side of field
   */
  Append: FieldGroupAppend
});

export default FieldGroup;
